import React from "react";
import translate from "../../../i18n/translate";
import "./NoDataFound.scss";

const NoDataFound = () => {
    return (
        <React.Fragment>
            <div className="no-data-tab">{translate("progress_tab_nodata")}</div>
        </React.Fragment>
    )
}

export default NoDataFound;